import { getAllAccounts, getCurrentAccount, switchToAccount as switchAccount, removeAccount, clearAllAccounts, loadSessionString, hasStoredSessionString } from './sessions';
import { StringSession } from '../lib/gramjs/sessions';
import type { ApiSessionData } from '../api/types';

export function switchToAccountBySessionString(sessionString: string): boolean {
  try {
    const stringSession = new StringSession(sessionString);
    stringSession.load();
    const sessionData = stringSession.getSessionData();
    
    if (!sessionData || Object.keys(sessionData.keys).length === 0) {
      return false;
    }
    
    localStorage.setItem('telegram_session_string', sessionString);
    
    localStorage.setItem('session_user_auth', JSON.stringify({
      dcID: sessionData.mainDcId,
      id: 'unknown_user',
      test: sessionData.isTest,
    }));
    localStorage.setItem('dc', String(sessionData.mainDcId));
    
    window.location.reload();
    
    return true;
  } catch (error) {
    return false;
  }
}

export function switchToAccountByUserId(userId: string): boolean {
  try {
    const success = switchAccount(userId);
    if (!success) {
      return false;
    }
    
    window.location.reload();
    
    return true;
  } catch (error) {
    return false;
  }
}

export function logoutAndClearSession(): void {
  try {
    localStorage.removeItem('telegram_session_string');
    
    clearAllAccounts();
    
    localStorage.removeItem('session_user_auth');
    localStorage.removeItem('dc');
    localStorage.removeItem('current_account_id');
    
    [1, 2, 3, 4, 5].forEach((dcId) => {
      localStorage.removeItem(`dc${dcId}_auth_key`);
      localStorage.removeItem(`dc${dcId}_hash`);
      localStorage.removeItem(`dc${dcId}_server_salt`);
    });
    
    window.location.reload();
  } catch (error) {
  }
}

export function getCurrentSessionString(): string | null {
  return loadSessionString();
}

export function hasSessionString(): boolean {
  return hasStoredSessionString();
}

if (typeof window !== 'undefined') {
  (window as any).switchToAccountBySessionString = switchToAccountBySessionString;
  (window as any).switchToAccountByUserId = switchToAccountByUserId;
  (window as any).logoutAndClearSession = logoutAndClearSession;
  (window as any).getCurrentSessionString = getCurrentSessionString;
  (window as any).hasSessionString = hasSessionString;
  (window as any).getAllAccounts = getAllAccounts;
  (window as any).getCurrentAccount = getCurrentAccount;
  (window as any).removeAccount = removeAccount;
  (window as any).clearAllAccounts = clearAllAccounts;
}